<template>
  <div
    ref="focusable"
    class="focusable"
    :class="staticClass"
    tabindex="1000"
  >
    <slot />
  </div>
</template>

<script lang="ts">

export default {
  name: 'Focusable',

  props: {
    tvRequestFocus: {
      type: Boolean,
      default: false,
    },

    focusClass: {
      type: String,
      default: '',
    },

    staticClass: {
      type: String,
      default: '',
    },
  },
};
</script>
